import { rtkApi } from '../rtkApi';

export type DocumentRequirementRow = {
  _id: string;
  scope: string;
  scopeId: string;
  requirementKey: string;
  displayLabel: string;
  status: string;
  source: string;
  dueDate?: string;
  notes?: string;
  sortOrder?: number;
  contextSnapshot?: {
    loanEstimationType?: string;
    loanProgram?: string;
    occupancy?: string;
  };
};

export type DocumentSubmissionRow = {
  _id: string;
  requirementId?: string | null;
  scope: string;
  scopeId: string;
  requirementKey: string;
  storage: { provider?: string; url?: string; key?: string; bucket?: string };
  fileName: string;
  reviewStatus: string;
  uploadedByUserId: string;
  createdAt?: string;
};

export type DocumentReadinessSummary = {
  cartGateMet: boolean;
  fullUserReady: boolean;
  contractCartGateKeys: string[];
  missingKeys: string[];
  requirements: DocumentRequirementRow[];
  submissions: DocumentSubmissionRow[];
  legacyDocumentCount: number;
  usedLegacyFallback: boolean;
};

export const documentRequirementsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentReadinessSummary: builder.query<DocumentReadinessSummary, void>({
      query: () => ({ url: '/document-requirements/summary' }),
      transformResponse: (response: {
        success: boolean;
        data: DocumentReadinessSummary;
      }) => response.data,
      providesTags: ['DocumentRequirements'],
    }),
    syncUserDocumentRequirements: builder.mutation<
      { success: boolean; data: unknown },
      void
    >({
      query: () => ({
        url: '/document-requirements/sync-user',
        method: 'POST',
      }),
      invalidatesTags: ['DocumentRequirements'],
    }),
    syncProductDocumentRequirements: builder.mutation<
      { success: boolean; data: unknown },
      string
    >({
      query: (productId) => ({
        url: `/document-requirements/sync-product/${productId}`,
        method: 'POST',
      }),
      invalidatesTags: ['DocumentRequirements'],
    }),
    listDocumentRequirementsByScope: builder.query<
      {
        success: boolean;
        data: { requirements: unknown[]; submissions: unknown[] };
      },
      { scope: string; scopeId: string }
    >({
      query: ({ scope, scopeId }) => ({
        url: '/document-requirements/list',
        params: { scope, scopeId },
      }),
      providesTags: ['DocumentRequirements'],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetDocumentReadinessSummaryQuery,
  useSyncUserDocumentRequirementsMutation,
  useSyncProductDocumentRequirementsMutation,
  useListDocumentRequirementsByScopeQuery,
} = documentRequirementsApi;
